/**
 * Environment-specific SVG rock asset.
 * Rendered inside .rock div which clips it via border-radius.
 * variant: 'forest' | 'desert' | 'snow' | 'castle' | 'water' | 'graveyard' | 'inferno'
 */

const BODY = 'M 15,65 Q 8,45 20,30 Q 35,12 55,10 Q 75,8 85,25 Q 95,42 88,62 Q 80,80 62,86 Q 40,92 22,80 Z';
const HI   = 'M 28,34 Q 34,18 52,18 Q 64,20 60,34 Q 48,44 28,40 Z';
const SHAD = 'M 24,78 Q 40,92 62,86 Q 80,80 88,62 Q 82,74 64,82 Q 42,88 24,78 Z';

function ForestRock() {
  return (
    <>
      <rect width="100" height="100" fill="#7a8a72" />
      <path d={BODY} fill="#7a8a72" />
      {/* Moss patch along top */}
      <path d="M 20,30 Q 35,12 55,10 Q 72,10 82,24 Q 62,15 45,18 Q 28,22 20,30 Z" fill="#5a9030" opacity="0.9" />
      {/* Small moss blob left */}
      <ellipse cx="30" cy="38" rx="10" ry="5" fill="#4a8020" opacity="0.6" />
      {/* Highlight */}
      <path d={HI} fill="#b0c0a8" opacity="0.42" />
      {/* Shadow base */}
      <path d={SHAD} fill="#4a5a42" />
    </>
  );
}

function DesertRock() {
  return (
    <>
      <rect width="100" height="100" fill="#c09050" />
      <path d={BODY} fill="#c09050" />
      {/* Sediment layers */}
      <line x1="26" y1="42" x2="80" y2="36" stroke="#8a6020" strokeWidth="2.5" opacity="0.55" />
      <line x1="22" y1="56" x2="85" y2="50" stroke="#8a6020" strokeWidth="2" opacity="0.50" />
      <line x1="24" y1="70" x2="84" y2="66" stroke="#8a6020" strokeWidth="2" opacity="0.45" />
      {/* Highlight */}
      <path d={HI} fill="#e8d090" opacity="0.42" />
      {/* Shadow base */}
      <path d={SHAD} fill="#7a5020" />
    </>
  );
}

function SnowRock() {
  return (
    <>
      <rect width="100" height="100" fill="#7a8898" />
      <path d={BODY} fill="#7a8898" />
      {/* Snow cap */}
      <path d="M 20,30 Q 35,12 55,10 Q 72,10 84,24 Q 68,20 55,22 Q 38,26 24,36 Z" fill="#e8f4ff" />
      {/* Snow inner glow */}
      <path d="M 32,24 Q 44,14 58,14 Q 68,16 64,22 Q 52,18 40,20 Z" fill="white" opacity="0.7" />
      {/* Rock highlight */}
      <path d={HI} fill="#b8c8d8" opacity="0.3" />
      {/* Shadow base */}
      <path d={SHAD} fill="#5a6878" />
    </>
  );
}

function CastleRock() {
  return (
    <>
      <rect width="100" height="100" fill="#6a6a7a" />
      {/* Main stone block */}
      <rect x="8" y="16" width="84" height="72" rx="3" fill="#6a6a7a" />
      {/* Horizontal mortar */}
      <line x1="8" y1="46" x2="92" y2="46" stroke="#3a3a4a" strokeWidth="2.5" />
      {/* Vertical mortars — top row */}
      <line x1="50" y1="16" x2="50" y2="46" stroke="#3a3a4a" strokeWidth="2" />
      {/* Vertical mortars — bottom row (offset) */}
      <line x1="28" y1="46" x2="28" y2="88" stroke="#3a3a4a" strokeWidth="2" />
      <line x1="68" y1="46" x2="68" y2="88" stroke="#3a3a4a" strokeWidth="2" />
      {/* Top-left highlight */}
      <rect x="8" y="16" width="84" height="11" rx="2" fill="#8a8a9a" opacity="0.5" />
      {/* Right shadow edge */}
      <rect x="80" y="16" width="12" height="72" rx="2" fill="#2a2a3a" opacity="0.5" />
      {/* Bottom shadow */}
      <rect x="8" y="78" width="84" height="10" rx="2" fill="#2a2a3a" opacity="0.5" />
    </>
  );
}

function WaterRock() {
  return (
    <>
      <rect width="100" height="100" fill="#4a6070" />
      <path d={BODY} fill="#4a6070" />
      {/* Wet sheen — bright specular highlight */}
      <path d="M 34,26 Q 46,18 58,20 Q 58,30 46,36 Z" fill="#c0dce8" opacity="0.65" />
      {/* Secondary sheen */}
      <ellipse cx="64" cy="36" rx="6" ry="4" fill="#a0c8d8" opacity="0.40" />
      {/* Soft highlight band */}
      <path d={HI} fill="#7a9aaa" opacity="0.3" />
      {/* Shadow base */}
      <path d={SHAD} fill="#2a4050" />
    </>
  );
}

function GraveyardRock() {
  return (
    <>
      <rect width="100" height="100" fill="#3a3848" />
      <path d={BODY} fill="#3a3848" />
      <path d={HI} fill="#5a5870" opacity="0.38" />
      {/* Crack lines */}
      <path d="M 48,20 L 42,44 L 56,60 L 50,82" stroke="#1a1828" strokeWidth="2.5" fill="none" />
      <path d="M 48,20 L 42,44 L 56,60 L 50,82" stroke="#2a2838" strokeWidth="1" fill="none" opacity="0.5" />
      <path d="M 66,28 L 72,54 L 62,70" stroke="#1a1828" strokeWidth="2" fill="none" />
      {/* Shadow base */}
      <path d={SHAD} fill="#1a1828" />
    </>
  );
}

function InfernoRock() {
  return (
    <>
      <rect width="100" height="100" fill="#1a1515" />
      <path d={BODY} fill="#1a1515" />
      <path d={HI} fill="#2a2020" opacity="0.5" />
      {/* Glowing cracks — outer glow layer */}
      <path d="M 44,18 L 38,42 L 52,58 L 46,82" stroke="#ff6000" strokeWidth="5" fill="none" opacity="0.30" />
      <path d="M 66,28 L 72,52 L 62,68" stroke="#ff4000" strokeWidth="4" fill="none" opacity="0.25" />
      {/* Bright crack core */}
      <path d="M 44,18 L 38,42 L 52,58 L 46,82" stroke="#ffb040" strokeWidth="1.5" fill="none" opacity="0.95" />
      <path d="M 66,28 L 72,52 L 62,68" stroke="#ffb040" strokeWidth="1.2" fill="none" opacity="0.85" />
      {/* Small branch crack */}
      <path d="M 48,50 L 36,60" stroke="#ff8020" strokeWidth="1" fill="none" opacity="0.7" />
      {/* Shadow base */}
      <path d={SHAD} fill="#0e0a0a" />
    </>
  );
}

const VARIANTS = {
  forest:    ForestRock,
  desert:    DesertRock,
  snow:      SnowRock,
  castle:    CastleRock,
  water:     WaterRock,
  graveyard: GraveyardRock,
  inferno:   InfernoRock,
};

export function RockSvg({ variant }) {
  const Rock = VARIANTS[variant] ?? ForestRock;
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <Rock />
    </svg>
  );
}
